// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reachus-container {
  margin: 0;
  padding-top:30px;
  font-family: Arial, sans-serif;
  background-color: #f7f7f7;
  position: relative;
  min-height: 100vh; /* Full screen height */
  display: flex;
  justify-content: flex-start; /* Align form to the left */
  align-items: center;
  overflow: hidden; /* Prevent overflow */
  margin-top:50px;
}

.content-section {
  position: relative;
  width: 100%;
  height: 100vh; /* Full screen height */
  overflow: hidden;
}

.map-box {
  position: absolute; /* Allow the map to serve as the background */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* Cover entire container */
  z-index: 0; /* Ensure it's behind the form */
  pointer-events: auto; /* Prevent map interaction */
}

.map-box iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.form-box {
  margin-top:55px;
  position: relative;
  z-index: 2; /* Ensure it's above the map */
  background: rgba(255, 255, 255, 0.9); /* Semi-transparent background */
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
  max-width: 90%;
  margin-left: 70%; /* Align form to the left */
  text-align: left;
}

.contact-form label {
  margin-top: 10px;
  font-size: 0.85em; 
  font-weight: bold;
  color: #333;
}

.input-field,
.textarea-field {
  margin-top: 5px;
  width: 95%; 
  padding: 10px; 
  font-size: 0.9em; 
  border: 1px solid #ccc;
  border-radius: 5px;
}

.textarea-field {
  resize: none;
}

.send-button {
  width: 102%; 
  height: 40px;
  font-size: 1em; 
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.send-button:hover {
  background-color: #218838;
}


@media screen and (min-width: 1920px) {
.reachus-container{
  padding-top:50px;
}

}
/* Media Query for 1366px screen width */
@media (max-width: 1366px) {
  .reachus-container {
    margin: 0;
    padding-top:30px;
    font-family: Arial, sans-serif;
    background-color: #f7f7f7;
    position: relative;
    min-height: 100vh; /* Full screen height */
    display: flex;
    justify-content: flex-start; /* Align form to the left */
    align-items: center;
    overflow: hidden; /* Prevent overflow */
    margin-top:50px;
  }
  
  .content-section {
    position: relative;
    width: 100%;
    height: 100vh; /* Full screen height */
    overflow: hidden;
  }
  
  .map-box {
    position: absolute; /* Allow the map to serve as the background */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; /* Cover entire container */
    z-index: 0; /* Ensure it's behind the form */
    pointer-events: auto; /* Prevent map interaction */
  }
  
  .map-box iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  .form-box {
    margin-top:55px;
    position: relative;
    z-index: 2; /* Ensure it's above the map */
    background: rgba(255, 255, 255, 0.9); /* Semi-transparent background */
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
    max-width: 90%;
    margin-left: 70%; /* Align form to the left */
    text-align: left;
  }
  
  .contact-form label {
    margin-top: 10px;
    font-size: 0.85em; 
    font-weight: bold;
    color: #333;
  }
  
  .input-field,
  .textarea-field {
    margin-top: 5px;
    width: 95%; 
    padding: 10px; 
    font-size: 0.9em; 
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .textarea-field {
    resize: none;
  }
  
  .send-button {
    width: 102%; 
    height: 40px;
    font-size: 1em; 
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .send-button:hover {
    background-color: #218838;
  }
  
/* Mobile view */
@media (max-width: 768px) {
  .reachus-container {
    flex-direction: column; /* Stack the form and map vertically */
    align-items: center; /* Center the content */
    margin-top: 0px;
  }

  .map-box {
    pointer-events: auto;
    margin-top: 20px; /* Reduced margin for mobile */
    height: 200px; /* Reduce map height for mobile view */
    width: 100%; /* Adjust map width */
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Card effect for map */
    border-radius: 10px; /* Rounded corners */
    margin-bottom: 20px; /* Add some space below the map */
  }

  .form-box {
    width: 80%; /* Adjust width for mobile */
    margin-top: -50px; /* Add margin top */
  }

  .form-box, .map-box {
    border-radius: 10px; /* Apply rounded corners for cards */
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Apply card shadow effect */
  }

  .form-box {
    margin-top: 240px; /* Adjust top margin for the form */
    margin-left:20px;
  }
}
  }
`, "",{"version":3,"sources":["webpack://./src/components/ReachUs/ReachUs.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAE,uBAAuB;EAC1C,aAAa;EACb,2BAA2B,EAAE,2BAA2B;EACxD,mBAAmB;EACnB,gBAAgB,EAAE,qBAAqB;EACvC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,uBAAuB;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB,EAAE,6CAA6C;EACjE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY,EAAE,2BAA2B;EACzC,UAAU,EAAE,gCAAgC;EAC5C,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAE,8BAA8B;EAC1C,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;EACd,gBAAgB,EAAE,2BAA2B;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;AACA;EACE,gBAAgB;AAClB;;AAEA;AACA,wCAAwC;AACxC;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB,EAAE,uBAAuB;IAC1C,aAAa;IACb,2BAA2B,EAAE,2BAA2B;IACxD,mBAAmB;IACnB,gBAAgB,EAAE,qBAAqB;IACvC,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa,EAAE,uBAAuB;IACtC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB,EAAE,6CAA6C;IACjE,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAE,2BAA2B;IACzC,UAAU,EAAE,gCAAgC;IAC5C,oBAAoB,EAAE,4BAA4B;EACpD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU,EAAE,8BAA8B;IAC1C,oCAAoC,EAAE,gCAAgC;IACtE,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,cAAc;IACd,gBAAgB,EAAE,2BAA2B;IAC7C,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,gBAAgB;AAChB;EACE;IACE,sBAAsB,EAAE,sCAAsC;IAC9D,mBAAmB,EAAE,uBAAuB;IAC5C,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB,EAAE,8BAA8B;IAChD,aAAa,EAAE,sCAAsC;IACrD,WAAW,EAAE,qBAAqB;IAClC,2CAA2C,EAAE,wBAAwB;IACrE,mBAAmB,EAAE,oBAAoB;IACzC,mBAAmB,EAAE,iCAAiC;EACxD;;EAEA;IACE,UAAU,EAAE,4BAA4B;IACxC,iBAAiB,EAAE,mBAAmB;EACxC;;EAEA;IACE,mBAAmB,EAAE,oCAAoC;IACzD,2CAA2C,EAAE,6BAA6B;EAC5E;;EAEA;IACE,iBAAiB,EAAE,mCAAmC;IACtD,gBAAgB;EAClB;AACF;EACE","sourcesContent":[".reachus-container {\n  margin: 0;\n  padding-top:30px;\n  font-family: Arial, sans-serif;\n  background-color: #f7f7f7;\n  position: relative;\n  min-height: 100vh; /* Full screen height */\n  display: flex;\n  justify-content: flex-start; /* Align form to the left */\n  align-items: center;\n  overflow: hidden; /* Prevent overflow */\n  margin-top:50px;\n}\n\n.content-section {\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Full screen height */\n  overflow: hidden;\n}\n\n.map-box {\n  position: absolute; /* Allow the map to serve as the background */\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; /* Cover entire container */\n  z-index: 0; /* Ensure it's behind the form */\n  pointer-events: auto; /* Prevent map interaction */\n}\n\n.map-box iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.form-box {\n  margin-top:55px;\n  position: relative;\n  z-index: 2; /* Ensure it's above the map */\n  background: rgba(255, 255, 255, 0.9); /* Semi-transparent background */\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  width: 350px;\n  max-width: 90%;\n  margin-left: 70%; /* Align form to the left */\n  text-align: left;\n}\n\n.contact-form label {\n  margin-top: 10px;\n  font-size: 0.85em; \n  font-weight: bold;\n  color: #333;\n}\n\n.input-field,\n.textarea-field {\n  margin-top: 5px;\n  width: 95%; \n  padding: 10px; \n  font-size: 0.9em; \n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.textarea-field {\n  resize: none;\n}\n\n.send-button {\n  width: 102%; \n  height: 40px;\n  font-size: 1em; \n  background-color: #28a745;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.send-button:hover {\n  background-color: #218838;\n}\n\n\n@media screen and (min-width: 1920px) {\n.reachus-container{\n  padding-top:50px;\n}\n\n}\n/* Media Query for 1366px screen width */\n@media (max-width: 1366px) {\n  .reachus-container {\n    margin: 0;\n    padding-top:30px;\n    font-family: Arial, sans-serif;\n    background-color: #f7f7f7;\n    position: relative;\n    min-height: 100vh; /* Full screen height */\n    display: flex;\n    justify-content: flex-start; /* Align form to the left */\n    align-items: center;\n    overflow: hidden; /* Prevent overflow */\n    margin-top:50px;\n  }\n  \n  .content-section {\n    position: relative;\n    width: 100%;\n    height: 100vh; /* Full screen height */\n    overflow: hidden;\n  }\n  \n  .map-box {\n    position: absolute; /* Allow the map to serve as the background */\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; /* Cover entire container */\n    z-index: 0; /* Ensure it's behind the form */\n    pointer-events: auto; /* Prevent map interaction */\n  }\n  \n  .map-box iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n  \n  .form-box {\n    margin-top:55px;\n    position: relative;\n    z-index: 2; /* Ensure it's above the map */\n    background: rgba(255, 255, 255, 0.9); /* Semi-transparent background */\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    width: 350px;\n    max-width: 90%;\n    margin-left: 70%; /* Align form to the left */\n    text-align: left;\n  }\n  \n  .contact-form label {\n    margin-top: 10px;\n    font-size: 0.85em; \n    font-weight: bold;\n    color: #333;\n  }\n  \n  .input-field,\n  .textarea-field {\n    margin-top: 5px;\n    width: 95%; \n    padding: 10px; \n    font-size: 0.9em; \n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  .textarea-field {\n    resize: none;\n  }\n  \n  .send-button {\n    width: 102%; \n    height: 40px;\n    font-size: 1em; \n    background-color: #28a745;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n  }\n  \n  .send-button:hover {\n    background-color: #218838;\n  }\n  \n/* Mobile view */\n@media (max-width: 768px) {\n  .reachus-container {\n    flex-direction: column; /* Stack the form and map vertically */\n    align-items: center; /* Center the content */\n    margin-top: 0px;\n  }\n\n  .map-box {\n    pointer-events: auto;\n    margin-top: 20px; /* Reduced margin for mobile */\n    height: 200px; /* Reduce map height for mobile view */\n    width: 100%; /* Adjust map width */\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Card effect for map */\n    border-radius: 10px; /* Rounded corners */\n    margin-bottom: 20px; /* Add some space below the map */\n  }\n\n  .form-box {\n    width: 80%; /* Adjust width for mobile */\n    margin-top: -50px; /* Add margin top */\n  }\n\n  .form-box, .map-box {\n    border-radius: 10px; /* Apply rounded corners for cards */\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Apply card shadow effect */\n  }\n\n  .form-box {\n    margin-top: 240px; /* Adjust top margin for the form */\n    margin-left:20px;\n  }\n}\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
